import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface MigrationPreviewErrorProps {
  onRetry: () => void;
}

export const MigrationPreviewError: FC<MigrationPreviewErrorProps> = ({ onRetry }) => (
  <div style={{ textAlign: 'center', padding: 24 }}>
    <Typography variant="body2" color="error" sx={{ mb: 2 }}>
      Couldn&apos;t build the migration preview.
    </Typography>
    <Button variant="outlined" onClick={onRetry}>
      Retry
    </Button>
  </div>
);
